const URLSlagMap = {
  subscribe: {
    guid: undefined
  },
  main: {
    guid: undefined
  },
  'new-features': {
    guid: 'ff94eb9c-715a-4607-9cbe-be135e9c27c0'
  },
  'bug-fixes': {
    guid: '39b98e78-769b-4802-9c9a-fa6f5626cb3f'
  },
  'wix-home': {
    guid: 'a1e5822e-ddb0-4c27-911b-3e9f443137d9'
  },
  'wix-editor': {
    guid: '033fc226-540b-463d-b1b4-9c77a6f24c93'
  },
  'wix-adi': {
    guid: '9a506c29-8025-4799-857d-69fdc61cc192'
  },
  'wix-stores': {
    guid: '524b7c37-2223-42c2-91d8-94e24aa8e60c'
  },
  'wix-mobile-app': {
    guid: '0af2e69c-897f-4d25-a684-ccae53e1b2a1'
  },
  'wix-promote': {
    guid: '7e961c43-7f7f-46fd-b2f8-adc55ab8efea'
  },
  'wix-music': {
    guid: 'c30a5651-2b30-4c19-bb56-db52872a8512'
  },
  'wix-restaurants': {
    guid: '68d6d6de-e1bf-456b-bd8f-9dadb0a18e16'
  },
  'wix-photography': {
    guid: 'eda41dad-f2e1-4f11-81b4-f0d0228e9111'
  },
  'wix-video': {
    guid: '4bd0a927-464c-471d-b097-045ea9e44332'
  },
  'wix-forum': {
    guid: 'd6716013-683e-4c07-8303-d8aca036defa'
  },
  'wix-blog': {
    guid: '94a02e79-c101-44c3-82af-fb188aab4400'
  },
  'wix-bookings': {
    guid: '21765ed5-de64-4ce6-a4b6-c2405d3d61d5'
  },
  'wix-hotels': {
    guid: '6a36f502-c629-460f-817f-bdb0f7abd949'
  },
  'wix-app-market': {
    guid: '932f3702-1be6-42b9-b344-a4a094e83b19'
  },
  'wix-invoices': {
    guid: 'eae87d70-77bb-4b91-8f13-ddb562a1fab4'
  },
  'wix-inbox': {
    guid: '7a75ae5c-ba6a-46c7-b10a-ac9fdf87caee'
  },
  'wix-pro-gallery': {
    guid: '02731168-6100-4326-a7bf-bf01088b7a32'
  },
  'wix-events': {
    guid: 'c6892197-aa67-4401-a9b3-3ae86c527f57'
  },
  'wix-seo-tools': {
    guid: '0515bc21-3703-478d-8a11-505faa9201f0'
  },
  corvid: {
    guid: 'e6494d5d-8eba-4d37-ae45-8281c1b70837'
  },
  velo: {
    guid: 'e6494d5d-8eba-4d37-ae45-8281c1b70837'
  },
  payments: {
    guid: '4a5ccee8-a01a-478a-bc55-733d15b53738'
  }
};

export const getGuidByLabel = label => {
  return !URLSlagMap[label] ? URLSlagMap.main.guid : URLSlagMap[label].guid;
};

export const tagsListToIgnore = label => {
  return ['bug-fixes'].indexOf(label) !== -1 ? [] : [getGuidByLabel('bug-fixes')];
};

export const validateTag = tag => {
  if (URLSlagMap[tag]) {
    return tag;
  }
  if (tag === '') {
    return 'main';
  }
  return false;
};

export const doesLabelExist = label => {
  return !!URLSlagMap[label];
};
